module.exports = __webpack_public_path__ + "static/media/collage_edit_article.afbb4735.jpg";